<template>
  <div class="card-base ph-10" v-loading="isLoading">
    <h5 class="ml-10 pt-10 display-block">
      Assets
      <el-link @click="loadDocumentation('dashboard-assets')" :underline="false">
        <i class="material-icons">help_outline</i>
      </el-link>
    </h5>
    <el-divider></el-divider>
    <div class="widget-header">
      <span class="display-block subtitle2 pt-10">VMs</span>
      <el-row
          type="flex"
          class="ph-10 pt-10 host-widget-info text-truncate animated fadeInRight cursor-pointer"
          @click.native="gotoView('hosts', {}, { discovered: true })"
      >
        <el-col :span="20">
          <span class="ml-0 widget-title display-block subtitle2 light-bold">Discovered</span>
        </el-col>
        <el-col :span="4">
          <span class="ml-0 widget-count light-bold">
            <!-- {{ discoverdAgentCount }} -->
            {{ assetSummaryView.numVmsDiscovered }}
          </span>
        </el-col>
      </el-row>
      <el-row
          type="flex"
          class="ph-10 host-widget-info text-truncate animated fadeInRight cursor-pointer"
          @click.native="gotoView('hosts', {}, { protected: true })"
      >
        <el-col :span="20">
          <span class="ml-0 widget-title display-block subtitle2 light-bold">Monitoring</span>
        </el-col>
        <el-col :span="4">
          <span class="ml-0 widget-count light-bold">
            <!-- {{ activeAgentSummary.protectedCount }} -->
            {{ assetSummaryView.numVmsMonitored }}
          </span>
        </el-col>
      </el-row>
      <el-row
          type="flex"
          class="ph-10 pb-10 host-widget-info at-risk  text-truncate animated fadeInLeft cursor-pointer"
          @click.native="gotoView('hosts', {}, { atrisk: true })"
      >
        <el-col :span="20">
          <span class="ml-0 widget-title display-block subtitle2 light-bold">At Risk</span>
        </el-col>
        <el-col :span="4">
          <span class="ml-0 widget-count light-bold">
            <!-- {{ activeAgentSummary.atRiskCount || 0 }} -->
            {{ assetSummaryView.numVmsRisky || 0 }}
            </span>
        </el-col>
      </el-row>
    </div>
    <div class="widget-header">
      <span class="display-block subtitle2">CONTAINERS</span>
      <el-row
          type="flex"
          class="ph-10 pt-10 host-widget-info  text-truncate animated fadeInRight cursor-pointer"
          @click.native="gotoView('containers', {}, {})"
      >
        <el-col :span="20">
          <span class="ml-0 widget-title display-block subtitle2 light-bold">Discovered</span>
        </el-col>
        <el-col :span="4">
          <span class="ml-0 widget-count light-bold display-block">
            <!-- {{ containerListSummary.containerCount }} -->
            {{ assetSummaryView.numContainersDiscovered }}
          </span>
        </el-col>
      </el-row>
      <el-row
          type="flex"
          class="ph-10 host-widget-info  text-truncate animated fadeInRight cursor-pointer"
          @click.native="gotoView('containers', {}, { protected: true })"
      >
        <el-col :span="20">
          <span class="ml-0 widget-title display-block subtitle2 light-bold">Monitoring</span>
        </el-col>
        <el-col :span="4">
          <span class="ml-0 widget-count light-bold display-block">
            <!-- {{ containerListSummary.protectedCount }} -->
            {{ assetSummaryView.numContainersMonitored }}
          </span>
        </el-col>
      </el-row>
      <el-row
          type="flex"
          class="ph-10 pb-10 host-widget-info at-risk text-truncate animated fadeInLeft cursor-pointer"
          @click.native="gotoView('containers', {}, { atrisk: true })"
      >
        <el-col :span="20">
          <span class="ml-0 widget-title display-block subtitle2 light-bold">At Risk</span>
        </el-col>
        <el-col :span="4">
          <span class="ml-0 widget-count light-bold display-block">
            <!-- {{ containerListSummary.atRiskCount || 0 }} -->
            {{ assetSummaryView.numContainersRisky || 0 }}
          </span>
        </el-col>
      </el-row>
    </div>
    <div class="widget-header">
      <span class="display-block subtitle2">CONTAINERS IMAGES</span>
      <el-row
          type="flex"
          class="ph-10 pt-10 host-widget-info  text-truncate animated fadeInRight cursor-pointer"
          @click.native="gotoView('container-images', {}, {})"
      >
        <el-col :span="20">
          <span class="ml-0 widget-title display-block subtitle2 light-bold">Discovered</span>
        </el-col>
        <el-col :span="4">
          <span class="ml-0 widget-count light-bold display-block">
            <!-- {{ containerImagesListSummary.containerCount }} -->
            {{ assetSummaryView.numContainerImagesDiscovered }}
          </span>
        </el-col>
      </el-row>
      <el-row
          type="flex"
          class="ph-10 pb-10 host-widget-info at-risk text-truncate animated fadeInLeft cursor-pointer"
          @click.native="gotoView('container-images', {}, { vulnerable: 'HIGH'})"
      >
        <el-col :span="20">
          <span class="ml-0 widget-title display-block subtitle2 light-bold">Vulnerable</span>
        </el-col>
        <el-col :span="4">
          <!-- <span class="ml-0 widget-count light-bold display-block">{{
            containerImagesListSummary.snykVulernableCount || 0
          }}</span> -->
          <span class="ml-0 widget-count light-bold display-block">{{
              assetSummaryView.numContainerImagesRisky || 0
            }}</span>
        </el-col>
      </el-row>
    </div>
    <div class="pt-5 flex justify-center align-center cursor-pointer">
      <router-link :to="{ name: 'integrations' }">
        <a class="display-inline-block capitalize-first-letter">Add Assets</a>
      </router-link>
    </div>
    <div class="widget-header">
      <span class="display-block subtitle2 pt-5">UNPROTECTED ASSETS</span>
      <el-row type="flex" class="ph-10 pt-5">
        <el-col :span="12" style="width:49%">
          <span class="ml-0 widget-count light-bold display-block"
          >{{ activeAgentSummary.unprotectedCount }} of {{ activeAgentSummary.assetCount }} VMs are not
            protected.</span
          >
        </el-col>
        <el-col :span="12" style="margin-left:-16px;">
          <el-progress
              type="circle"
              :percentage="unprotectedPercentage"
              :stroke-width="parseInt(10)"
              color="#ee3354"
          ></el-progress>
        </el-col>
      </el-row>
    </div>
    <div class="pt-5 flex justify-center align-center cursor-pointer">
      <router-link :to="{ name: 'installation' }">
        <a class="display-inline-block">Add Confluera Agents</a>
      </router-link>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'
import {registerInverval, destroyInverval} from '@/utilities/global.interval'

import {DASHBOARD_ASSET_MONITORING_INTERVAL} from '@/constants/polling-interval.constants'
import {TRAIL_SUMMARY_REQ} from '@/store/modules/trails/trailsinfo.type'
import {
  AGENT_LIST_REQ,
  CONTAINER_LIST_REQ,
  CONTAINER_PROGRESSION_COUNT_REQ,
  CONTAINER_IMAGES_LIST_REQ,
  ASSET_SUMMARY_VIEW
} from '@/store/modules/agents/agents.type'

export default {
  name: 'AssetMonitoring',
  mixins: [loadDocumentationMixin],
  props: {
    agent: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      isLoading: false,
      decommissionableAgents: 0,
      upgradeableAgents: 0,
      assetDetailsIntervalId: {},
      discoverdAgentCount: 0,
      assetSummaryRecords: {}
    }
  },
  mounted() {
  },
  created() {
    this.$store.dispatch(ASSET_SUMMARY_VIEW).then(() => {
      this.isLoading = false
    })
  },
  methods: {
    pollAssetInfo() {
      this.assetDetailsIntervalId = setTimeout(() => {
        this.fetchAssetInfo()
      }, DASHBOARD_ASSET_MONITORING_INTERVAL)

      registerInverval(this.assetDetailsIntervalId)
    },
    fetchAssetInfo() {
      if (this.assetDetailsIntervalId) {
        destroyInverval(this.assetDetailsIntervalId)
      }
      Promise.all([
        this.$store.dispatch(TRAIL_SUMMARY_REQ),
        this.$store.dispatch(AGENT_LIST_REQ),
        this.$store.dispatch(CONTAINER_LIST_REQ),
        this.$store.dispatch(CONTAINER_PROGRESSION_COUNT_REQ),
        this.$store.dispatch(CONTAINER_IMAGES_LIST_REQ)
      ]).then(
          apiResponses => {
            this.decommissionableAgents = _.filter(apiResponses[1].models, {decommissionEligibile: true}).length
            this.upgradeableAgents = _.filter(apiResponses[1].models, {upgradeable: true}).length
            this.isLoading = false
            this.pollAssetInfo()
            this.discoverdAgentCount = _.filter(apiResponses[1].models, {discovered: 'discovered'}).length
          },
          errMsg => {
            this.pollAssetInfo()
          }
      )
    },
    gotoView(pathName, params, query) {
      this.$router.push({
        name: pathName,
        query: query,
        params: params
      })
    }
  },
  computed: {
    ...mapGetters([
      'trailSummary',
      'agentList',
      'containerListInfo',
      'activeAgentSummary',
      'containerListSummary',
      'containerImagesListSummary',
      'containerThreatProgressionCount',
      'assetSummaryView'
    ]),
    protectedPercentage() {
      if (this.activeAgentSummary.assetCount === 0) {
        return this.activeAgentSummary.assetCount
      }
      return Math.ceil(
          (
              (parseInt(this.activeAgentSummary.protectedCount) / parseInt(this.activeAgentSummary.assetCount)) *
              100
          ).toFixed(2)
      )
    },
    unprotectedPercentage() {
      if (this.activeAgentSummary.assetCount === 0) {
        return this.activeAgentSummary.assetCount
      }
      return Math.ceil(
          (
              (parseInt(this.activeAgentSummary.unprotectedCount) / parseInt(this.activeAgentSummary.assetCount)) *
              100
          ).toFixed(2)
      )
    }
  },
  beforeDestroy() {
    // kill interval calls
    this.pollAssetInfo = function () {
    }
    destroyInverval(this.assetDetailsIntervalId)
  },
  components: {}
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/riskscore_colors.css';

.card-base {
  height: inherit;
}

.material-icons {
  font-size: 20px;
  color: var(--aluminum-400);
  line-height: 27px;
  vertical-align: text-top;
}

.el-divider--horizontal {
  display: block;
  height: 1px;
  width: calc(100% - 20px);
  margin-left: 10px;
  margin-top: 5px;
  margin-bottom: 0px;
}

span {
  &.ml-10 {
    margin-left: 10px;
  }

  &.ml-20 {
    margin-left: 20px;
  }

  &.ml-0 {
    margin-left: 0px;
  }
}

.widget-header {
  padding-bottom: 10px;
}

.host-widget-info {
  background-color: var(--aluminum-100);

  &.at-risk {
    color: var(--amaranth-500);
  }

  .widget-title {
    font-weight: 600;
  }

  .widget-count {
  }
}

.at-risk {
  color: var(--amaranth-500);
}

>>> .el-progress--circle {
  margin: auto;
}

>>> .el-progress--circle .el-progress__text,
.el-progress--dashboard .el-progress__text {
  color: #ee3354;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/AssetMonitoring.vue